/**
 * Record grain for views / field scope.
 *
 * - `Primary` — root document row
 * - `Secondary` — first entity-owned embedded level only (back-compat for stage boards)
 * - `Any` — no field-domain grain filter; view unwind handling may still apply metadata defaults
 *
 * Path grains (e.g. `workOrders.codes`) are also accepted on views as plain strings so
 * n-level boards can page/filter at deeper array elements. See `resolveUnwindPaths`.
 */
export enum MetadataEntityRecordScope {
    Primary = 'primary',
    Secondary = 'secondary',
    Any = 'any',
}

/** Enum grain or absolute embedded path (`workOrders`, `workOrders.codes`, …). */
export type MetadataEntityRecordExtendedScope = MetadataEntityRecordScope | (string & {});
